import React from 'react';
import classNames from 'classnames';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { AnimationProps, FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Rotate = '0' | '90' | '180' | '270';

const RotateToClassname: Record<Rotate, string> = {
  '0': '',
  '180': 'rotate-180',
  '270': 'rotate-270',
  '90': 'rotate-90',
};

export type IconProps = {
  icon: IconDefinition;
  size: number;
  className?: string;
  rotate?: Rotate;
  animationProps?: AnimationProps;
};

export const IconContainer = ({ rotate = '0', ...props }: IconProps) => {
  return (
    <div
      className={classNames(
        'flex justify-center items-center overflow-visible',
        props.className,
        RotateToClassname[rotate]
      )}
      style={{
        width: `${props.size}px`,
        height: `${props.size}px`,
        fontSize: `${props.size}px`,
      }}
    >
      <FontAwesomeIcon icon={props.icon} {...props.animationProps} />
    </div>
  );
};
